import {
  Form, Link, SidebarModal, Text,
} from '@domain-group/suit-theme'

import ComparableResult from '@components/ComparableResult'

import { getSavedDataProviderIds } from '@functions/campaignComparable'

import useCampaignComparables from '@hooks/useCampaignComparables'

import type { ModalCallbacks } from '@modals/BrowseCampaignComparablesModal'

import type { UseBrowseCampaignComparablesModalPayload } from '../../hooks/useBrowseCampaignComparablesModal'

import Filters from '../Filters'

interface BrowseComparablesProps {
  callbacks: ModalCallbacks,
  hookPayload: UseBrowseCampaignComparablesModalPayload,
}

const BrowseComparables = (props: BrowseComparablesProps) => {
  const { callbacks, hookPayload } = props
  const { createCampaignComparable } = callbacks

  const {
    browseComparableType,
    callbacks: {
      setModalState,
    },
    campaign,
    dataProviderPropertyId,
    filteredBrowseResults,
    filteredBrowseResultsCount,
    hasFilteredBrowseResults,
    showImages,
  } = hookPayload

  const { filteredCampaignComparables } = useCampaignComparables({ filters: { campaign_id: campaign.id } })
  const savedDataProviderIds = getSavedDataProviderIds(filteredCampaignComparables)

  return (
    <>
      <Form.Field
        label="Browse a Category"
        labelRight={(<Text color="faintGrey" fontSize="xsmall">ID #{dataProviderPropertyId}</Text>)}
      >
        <select
          onChange={e => setModalState({ browseComparableType: e.target.value })}
          value={browseComparableType}
        >
          <option value="">Please Select...</option>
          <option value="market_all">All in the market</option>
          <option value="agency_all">All in your agency</option>
          <option value="market_current">Listed in the market</option>
          <option value="agency_current">Listed by your agency</option>
          <option value="market_sold">Sold in the market</option>
          <option value="agency_sold">Sold by your agency</option>
          <option value="market_rental">Rental Comparables in the market</option>
        </select>
      </Form.Field>

      {!!browseComparableType && <Filters hookPayload={hookPayload} />}

      {hasFilteredBrowseResults && (
        <>
          <SidebarModal.Separator boxProps={{ marginTop: 'large' }} />

          {/*
           // @ts-expect-error TS2741 */}
          <Form.Field
            label={`${filteredBrowseResultsCount} Results Found`}
            labelRight={(
              <Link onClick={() => setModalState({ showImages: !showImages })} textProps={{ fontSize: 'xsmall' }}>
                {showImages ? 'Hide Images' : 'Show Images'}
              </Link>
            )}
            marginTop="large"
          />

          {filteredBrowseResults.map(browseResult => (
            <ComparableResult
              added={savedDataProviderIds.includes(browseResult.id)}
              browseResult={browseResult}
              callbacks={{ createCampaignComparable }}
              campaign={campaign}
              key={browseResult.id}
              showImages={showImages}
            />
          ))}
        </>
      )}
    </>
  )
}

export default BrowseComparables
